import { createApp } from "vue";
import { createHead } from "@unhead/vue";
import App from "./App.vue";
import { createPinia } from "pinia";
import router from "./router";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import VueGtag from "vue-gtag";

// Add icons to library
library.add(faEnvelope, faInstagram, faBars, faTimes);

const app = createApp(App);
const head = createHead();
const pinia = createPinia();

app.component("font-awesome-icon", FontAwesomeIcon);

app.use(head);
app.use(pinia);
app.use(router);
app.use(VueGtag, {
  config: { id: "UA-173153031-1" }
}, router);

app.mount("#app");
